export enum Commtype {
    Email,
    Phone,
    InPerson,
    Letter,
    Fax,
    CarrierPigeon
}